import { Trash } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Image, Input } from 'src/shared/components/ui'
import { Button } from 'src/shared/components/ui/button'
import { ImageItemProps } from '../types'

export const ImageItem = ({
  image_url,
  id,
  order,
  onOrderChange,
  onDelete,
}: ImageItemProps) => {
  return (
    <Column
      key={id}
      className="gap-3 bg-card p-3 rounded-lg border border-border shadow-sm hover:shadow-md transition-shadow group"
    >
      <div className="relative">
        <Image
          src={image_url || ''}
          alt="Product image"
          width={150}
          height={150}
          className="rounded-lg border-2 border-border object-cover w-full"
        />
        <Button
          size="icon"
          className="absolute -top-2 -right-2 h-6 w-6 bg-destructive hover:bg-destructive/90 text-white shadow-md opacity-0 group-hover:opacity-100 transition-opacity"
          variant="destructive"
          onClick={() => onDelete(id)}
        >
          <Trash className="h-3 w-3" />
        </Button>
      </div>

      <Row className="gap-2 items-center">
        <label className="text-xs text-muted-foreground whitespace-nowrap">
          Order:
        </label>
        <Input
          type="number"
          className="text-sm w-20 h-8"
          value={order}
          onChange={(e) => onOrderChange(id, Number(e.target.value))}
          min={0}
        />
      </Row>
    </Column>
  )
}

